import Intranet from "@/layouts/intranet/Index.vue";

export default {
  path: "/doors",
  component: Intranet,
  children: [
    {
      path: "",
      name: "doorsCrud",
      component: () => import("@/views/crud/ProductCrud.vue"),
      meta: {
        auth: true,
        serviceName: "products",
        title: "Productes",
      },
      children: [
        {
          path: ":id",
          name: "doorsCrudUpdate",
          // component: crudUpdate,
          component: () => import("@/views/services/DoorUpdate.vue"),
          meta: {
            auth: true,
            serviceName: "products",
            title: "Producte",
          },
        },
      ],
    },
  ],
};
